import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'common/components/elements/icons';
import './style.scss'

const PinLabel = ({
   margin,
   className,
   withoutDarkMode = false,
}) => {
   return (
      <div
         className={ `absolute right-0 top-0 h-6 w-6 bg-pending ${ withoutDarkMode ? '' : 'dark:bg-pending-dark' } mt-${ margin } mr-${ margin } z-1 rounded-full pin-label-content ${ className }` }>
         <Icon name='pin'
            color='major'
            darkColor={ withoutDarkMode ? 'major' : 'major-dark' }
         />
      </div>
   )
}
PinLabel.defaultProps = {
   margin: 2,
   className: '',
};

PinLabel.propTypes = {
   margin: PropTypes.number,
   className: PropTypes.string,
   withoutDarkMode: PropTypes.bool,
};
export default PinLabel
